class FormInput extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {        
        const closeIcon = this.querySelector(".form-input__icons .close");
        closeIcon?.addEventListener("click", this.clearInputValue.bind(this));

        const eyeIcon = this.querySelector(".form-input__icons .eye");
        eyeIcon?.addEventListener("click", this.onEyeClick.bind(this));

        const eyeOffIcon = this.querySelector(".form-input__icons .eye-off");
        eyeOffIcon?.addEventListener("click", this.onEyeOffClick.bind(this));
    }

    clearInputValue(event: Event) {
        const target = this.querySelector("input") as HTMLInputElement;
        target.value = "";
    }

    onEyeClick(event: Event) {
        const eyeIcon = this.querySelector(".form-input__icons .eye");
        const eyeOffIcon = this.querySelector(".form-input__icons .eye-off");
        const input = this.querySelector("input");

        eyeIcon?.classList.add("hidden");
        eyeOffIcon?.classList.remove("hidden");
        input?.setAttribute("type", "password");
    }

    onEyeOffClick(event: Event) {
        const eyeIcon = this.querySelector(".form-input__icons .eye");
        const eyeOffIcon = this.querySelector(".form-input__icons .eye-off");
        const input = this.querySelector("input");

        eyeIcon?.classList.remove("hidden");
        eyeOffIcon?.classList.add("hidden");
        input?.setAttribute("type", "text");
    }
}

customElements.define("form-input", FormInput);